export const setUTCDateFormate = (date: Date | string = new Date()) => {
    if (date instanceof Date) {
        date.setUTCHours(0, 0, 0, 0);
        return date.toISOString();
    }
    return date;
};
